import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, LabelList } from 'recharts';
import { Zap } from 'lucide-react';
import { computeSpPipelineData } from '../../utils/dashboardMetrics';

const STAGE_COLORS = {
  'Raffinage':           '#8B5CF6',
  'PO Review':           '#A855F7',
  'Spec Generation':     '#6366F1',
  'Confirmation': '#60A5FA',
  'Backlog Produit':     '#6B4C9A',
  'Backlog Sprint':      '#9B72CF',
  'En cours':            '#EC4899',
  'En Test':             '#F59E0B',
  'Test PO':             '#FB923C',
  'Test testeur':        '#FBBF24',
  'Tests à valider':     '#3B82F6',
  'Daily':               '#14B8A6',
  'Refaisage':           '#EF4444',
  'Done':                '#10B981',
};

const SHORT_LABELS = {
  'Confirmation': 'Confirmation',
  'Spec Generation':     'Spec Gen.',
  'Backlog Produit':     'Backlog Prod.',
  'Tests à valider':     'Tests val.',
};

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-100 px-4 py-3">
      <p className="text-xs font-semibold text-gray-700 mb-1">{d.stage}</p>
      <p className="text-sm font-bold text-purple-700">{d.storyPoints} SP</p>
      <p className="text-xs text-gray-500">{d.count} US</p>
    </div>
  );
};

const SpPipelineChart = ({ usStageGroups = [], sprintActif = false }) => {
  const raw = computeSpPipelineData(usStageGroups, sprintActif);
  const data = raw
    .filter(d => d.count > 0)
    .map(d => ({ ...d, label: SHORT_LABELS[d.stage] || d.stage }));

  const totalSP = raw.reduce((s, d) => s + d.storyPoints, 0);
  const totalUS = raw.reduce((s, d) => s + d.count, 0);

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 flex flex-col h-full">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-purple-50 rounded-xl flex items-center justify-center">
          <Zap className="w-5 h-5 text-purple-600" />
        </div>
        <div>
          <h3 className="text-sm font-bold text-gray-900">Pipeline SP</h3>
          <p className="text-xs text-gray-500">{totalUS} US · {totalSP} SP total</p>
        </div>
      </div>

      <div className="flex-1 min-h-[18rem]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 16, right: 8, left: 8, bottom: 48 }} barSize={28}>
            <XAxis
              dataKey="label"
              tick={{ fontSize: 10, fill: '#6B7280' }}
              axisLine={false}
              tickLine={false}
              interval={0}
              angle={-35}
              textAnchor="end"
            />
            <YAxis hide />
            <Tooltip content={<CustomTooltip />} cursor={{ fill: '#F9FAFB' }} />
            <Bar dataKey="storyPoints" radius={[4, 4, 0, 0]}>
              {data.map((entry, i) => (
                <Cell key={i} fill={STAGE_COLORS[entry.stage] || '#E5E7EB'} />
              ))}
              <LabelList
                dataKey="storyPoints"
                position="top"
                style={{ fontSize: 10, fill: '#374151', fontWeight: 600 }}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default SpPipelineChart;
